import React, { useState, useRef, useEffect, useMemo } from "react";
import styled from "styled-components";
import DrawingToolContainer from "./DrawingToolContainer";
import { continuekStore, studyCompleteStore } from "@stores/bookdata";
import BookSoundButton from "@components/elements/BookSoundButton";
import BookPreviewToolTip from "@components/elements/BookPreviewToolTip";
import Slider from "rc-slider";
import { zoomViewState } from "@stores/popup";
import FlipBook from "@components/modules/FlipBook";
import { useAtom, useSetAtom } from "jotai";
import { drawingTool, flipSound, blockTouch, loading } from "@stores/vars";
import { debounce } from "lodash";
import Drawing from "@/drawing";
import playSound from "@/sound";

const ControllerBar = styled.div`
  position: absolute;
  left: 80px;
  bottom: 25px;
  width: 1760px;
  height: 115px;
  background-color: #2d2a48;
  border-radius: 50px;
  animation: slideUp 0.8s cubic-bezier(0.65, 0, 0.35, 1);
  animation-delay: 0.5;
  z-index: 10;
`;

const SliderWrap = styled.div`
  width: 1040px;
  position: absolute;
  left: 350px;
  top: 40px;
  height: 40px;
  .rc-slider-handle-dragging {
    .preview-tooltip {
      display: block;
    }
  }
`;

const PencilButton = styled.button`
  width: 105px;
  height: 105px;
  display: inline-block;
  background: url(${require("@assets/img/tool_default.png")}) no-repeat;
  position: absolute;
  right: 190px;
  top: 5px;
  &.on {
    background: url(${require("@assets/img/tool_close.png")}) no-repeat;
  }
`;

const ZoomButton = styled.button`
  width: 105px;
  height: 105px;
  display: inline-block;
  background: url(${require("@assets/img/plus_default.png")}) no-repeat;
  position: absolute;
  right: 70px;
  top: 5px;
  &.disabled {
    opacity: 0.4;
    pointer-events: none;
  }
`;

const SwapButton = styled.button`
  position: absolute;
  left: -4px;
  top: -3px;
  width: 241px;
  height: 120px;
  background: url(${require("@assets/img/icon_animation_swap.png")}) no-repeat;
  &.disabled {
    pointer-events: none;
    filter: grayscale(1);
  }
`;

const PageButton = styled.button`
  position: absolute;
  left: 40px;
  top: 50%;
  transform: translateY(-50%);
  width: 117px;
  height: 117px;
  z-index: 10;
  opacity: 1;
  &.page-l {
    background: url(${require("@assets/img/icon_book_prev.png")}) no-repeat;
  }
  &.page-r {
    background: url(${require("@assets/img/icon_book_next.png")}) no-repeat;
    left: 1760px;
  }
`;

const BookCover = styled.div`
  position: relative;
  left: 50%;
  margin-left: -895px;
  top: 164px;
  width: 1790px;
  height: 872px;
  background: url(${require("@assets/img/book_cover.png")});
  opacity: 0;
  &.ty2 {
    background: url(${require("@assets/img/book_cover2.png")});
  }
`;

window.__continue_page = 1;

const Book = ({ data, onSwap, rememberPage }) => {
  const setContinueInfo = useSetAtom(continuekStore);
  const [currentCompleteStudy] = useAtom(studyCompleteStore);
  const [currentSliderCount, setSliderCount] = useState(1);
  const zoomViewInfo = useSetAtom(zoomViewState);
  const [isDrawing, setDrawing] = useAtom(drawingTool);
  const canvasStage = useRef();
  const isDrawingRef = useRef(false);
  const pages = data.pages;
  const thumPages = data.thumbnail;
  // 플립북 생성
  const makeFlipBook = () => {
    const wrap = document.querySelector("#bookContainer");
    const pagerUpdate = (page) => {
      if (page === 1) {
        wrap.classList.add("first");
      } else {
        wrap.classList.remove("first");
      }
      if (page === pages.length) {
        wrap.classList.add("last");
      } else {
        wrap.classList.remove("last");
      }
    };

    window.$("#flipbook").turn({
      width: 1664,
      height: 830,
      animatedAutoCenter: true,
      when: {
        turning: (e, page, view) => {
          const currentPage = view[1];
          pagerUpdate(currentPage);
          blockTouch();
          playSound.effect(flipSound);
          setSliderCount(currentPage);

          // 완료처리 및 이어보기 처리
          studyStateUpdate(currentPage);
          window.__saveCurPage = currentPage;
        },
        turned: (e, page, view) => {
          const currentPage = view[1];
          // console.log("\n\nturned==========================================");
          // console.log("isDrawingRef=> ", isDrawingRef.current);
          // console.log("current PageCount=> ", currentPage);
          // console.log("================================================");
          pagerUpdate(currentPage);
          blockTouch(false);
          if (isDrawingRef.current) {
            Drawing.show(currentPage);
            updateUndoRedo(Drawing.getCanvas(currentPage));
          }
        },
      },
    });

    callFlipBook("peel", false);
  };

  /**
   * 완료 or 이어보기 처리
   * @param {*} currentPage
   */
  const studyStateUpdate = (currentPage) => {
    //if (currentCompleteStudy.indexOf(data.key) === -1) {
    // 마지막 페이지
    if (currentPage >= pages.length) {
      // 완료처리 하지 않는다.
      //completeBook();
      // 다음 학습 자동언락은 없다.
      // unLockNextBook();

      setContinueInfo(null);
    } else {
      setContinueInfo({
        bookKey: data.key,
        page: currentPage,
      });
    }
    // }
  };

  // 현재 책 완료처리
  // const completeBook = () => {
  //   const newComplete = [...currentCompleteStudy];
  //   newComplete.push(data.key);
  //   // 현재
  //   setCompleteStudy(newComplete);
  // };

  // 다음 책 해금
  // const unLockNextBook = () => {
  //   const before = [...unlockedList];
  //   const currentIndex = window.__flatKeys.indexOf(data.key);
  //   const nextBookKey = window.__flatKeys[currentIndex + 1];
  //   if (before.indexOf(nextBookKey) === -1) {
  //     before.push(nextBookKey);
  //     setUnLock(before);
  //   }
  // };

  const initCanvas = () => {
    canvasStage.current = document.querySelector("#drawStage");
    Drawing.initCanvas(canvasStage.current, (pages.length - 1) / 2);
  };

  const updateUndoRedo = (canvas) => {
    if (canvas) {
    }
  };

  // 슬라이더 상태 변경 후 - 플립북 페이지만 업데이트
  const onAfterChangeSlider = async (value) => {
    if (value === currentSliderCount) return;
    if (isDrawing.active) {
      Drawing.hide();
      callFlipBook("disable", false);
    }
    callFlipBook("page", value);
  };

  // // 슬라이더 상태 변경 (state update)
  const onChangeSlider = (value) => {
    setSliderCount(value);
  };

  const onClickPencil = () => {
    setDrawing({
      active: !isDrawing.active,
    });
  };

  const onChangeColor = (color) => {
    Drawing.setColor(color);
  };

  const onClickZoom = () => {
    zoomViewInfo({
      open: true,
      page: currentSliderCount,
      pages: pages,
    });
  };

  // 이전 페이지
  const bookPrev = () => {
    callFlipBook("previous");
  };

  // 다음 페이지
  const bookNext = () => {
    callFlipBook("next");
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const delayedQueryCall = useMemo(() => debounce(() => onResize(), 100), []);

  // 플립북 메서드 호출
  const callFlipBook = (cmd, ...params) => {
    if (window.$("#flipbook").turn("is")) {
      window.$("#flipbook").turn(cmd, ...params);
    }
  };

  //화면 리사이즈 처리
  const onResize = () => {
    const curScale = window.__scale;
    const ORG_WIDTH = 1670;
    const ORG_HEIGHT = 830;
    const CUR_WIDTH = ORG_WIDTH * curScale;
    const CUR_PER = ORG_WIDTH / CUR_WIDTH;

    const el = document.querySelector("#flipbook");
    Object.assign(el.parentNode.style, {
      transform: `scale(${CUR_PER})`,
    });

    callFlipBook(
      "size",
      Math.ceil(ORG_WIDTH * curScale),
      Math.ceil(ORG_HEIGHT * curScale)
    );
  };

  useEffect(() => {
    window.addEventListener("resize", delayedQueryCall);
    makeFlipBook();
    onResize();
    initCanvas();

    // 북 페이지 진입 시 현재페이지 키 값 저장 ( 이어보기, 다음학습 관련 )
    if (currentCompleteStudy.indexOf(data.key) === -1) {
      if (window.__continue_page !== 1) {
        loading();
        setTimeout(() => {
          callFlipBook("page", window.__continue_page);
          loading(false);
        }, 200);
      } else {
        // setContinueInfo({
        //   bookKey: data.key,
        //   page: 1,
        // });
      }
    }

    if (window.__saveCurPage) {
      loading();
      setTimeout(() => {
        callFlipBook("page", window.__saveCurPage);
        loading(false);
      }, 200);
    }

    return () => {
      window.__continue_page = 1;
      window.$("#flipbook").turn("destroy");
      setDrawing(false);
      Drawing.destroy();
      window.removeEventListener("resize", delayedQueryCall);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isDrawing.active === true) {
      document.body.classList.add("drawing");
      Drawing.show(currentSliderCount);
      callFlipBook("disable", true);
      isDrawingRef.current = true;
    } else {
      document.body.classList.remove("drawing");
      Drawing.hide();
      callFlipBook("disable", false);
      isDrawingRef.current = false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDrawing.active]);

  return (
    <>
      <BookCover
        id="bookCover"
        className={data.categoryKey === "c8" && "ty2"}
      />
      <DrawingToolContainer onChangeColor={onChangeColor} />
      <FlipBook pages={pages} />

      <BookSoundButton data={pages[currentSliderCount - 2]} />
      <BookSoundButton cName="right" data={pages[currentSliderCount - 1]} />
      <ControllerBar>
        <SliderWrap>
          <Slider
            className={"book " + data.categoryKey}
            onAfterChange={onAfterChangeSlider}
            onChange={onChangeSlider}
            min={1}
            max={pages.length}
            step={2}
            value={currentSliderCount}
            handleRender={(renderProps) => {
              return (
                <div {...renderProps.props}>
                  {currentSliderCount === 1
                    ? `표지`
                    : currentSliderCount === 3
                    ? "타이틀"
                    : `${currentSliderCount - 3}-${currentSliderCount - 2}P`}
                  <BookPreviewToolTip
                    pages={thumPages}
                    data={currentSliderCount}
                  />
                </div>
              );
            }}
          />
        </SliderWrap>
        <SwapButton
          className={!data.mov.en && "disabled"}
          onClick={() => onSwap("video")}
        />
        <PencilButton
          onClick={onClickPencil}
          className={isDrawing.active ? "tool-pencil on" : "tool-pencil"}
        />
        <ZoomButton
          onClick={onClickZoom}
          // className={isDrawing.active ? "disabled" : ""}
          // className={"disabled"}
        />
      </ControllerBar>

      {!isDrawing.active && (
        <>
          <PageButton className="page-l" onClick={bookPrev} />
          <PageButton className="page-r" onClick={bookNext} />
        </>
      )}
    </>
  );
};

export default Book;
